import React from "react";
import { Link,Outlet } from "react-router-dom";
 
export default function CommunBankOwner(){
    return (
        <div>
            <div className=" flex flex-row space-x-2">
                <Link to="customers" className=" hover:text-blue-500">Customers</Link>
                <Link to="Farmers" className="hover:text-blue-500">Farmers</Link>
                <Link to="admins" className="hover:text-blue-500">Admins</Link>
            </div>
            <Outlet/>
        </div>
    )
}